import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map, size } from 'lodash-es'
import PropTypes from 'prop-types'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { MENU_NOT_SCRAPEABLE_REASONS } from '../../menus/constants'
import { DEFAULT_PAGE } from '../constants'

const MenuNotScrapeableReasonsFilter = ({ mode, disabled }) => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { menuNotScrapeableReasons } = getQueryParams(search)

  const handleChange = useCallback(
    menuNotScrapeableReasons =>
      history.push(
        createUrl(pathname, search, {
          menuNotScrapeableReasons,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  const getMaxTagPlaceholder = useCallback(
    omittedValues => `+ ${size(omittedValues)} more`,
    [],
  )

  return (
    <Form.Item label="Menu not scrapeable reason">
      <Select
        style={{ width: '100%' }}
        allowClear
        value={menuNotScrapeableReasons}
        mode={mode}
        onChange={handleChange}
        dropdownStyle={{ minWidth: 'fit-content' }}
        maxTagCount={1}
        maxTagPlaceholder={getMaxTagPlaceholder}
        disabled={disabled}
      >
        {map(MENU_NOT_SCRAPEABLE_REASONS, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

MenuNotScrapeableReasonsFilter.propTypes = {
  mode: PropTypes.string,
  disabled: PropTypes.bool,
}

MenuNotScrapeableReasonsFilter.defaultProps = {
  mode: 'default',
  disabled: false,
}

export default MenuNotScrapeableReasonsFilter
